import React, { FC, useState } from 'react';
import { Box, Typography, Button } from '@scope/scope-one-ui/core';
import { TileButton } from '@scope/scope-one-ui/core/TileButton';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@scope/scope-one-ui/theme';
import { AccentedWord, StepChoiceWrapper } from './PortfolioUploadSteps.styled';
import { PortfolioUploadFirstStepProps } from './PortfolioUploadFirstStep.d';
import Entities from '../../../../../assets/icons/entities.svg';
import Funds from '../../../../../assets/icons/funds.svg';
import { uploadSteps, uploadTypes } from '../constants';

export const PortfolioUploadFirstStep: FC<PortfolioUploadFirstStepProps> = ({
  changeUploadType,
  uploadType,
  setStep,
}) => {
  const { t } = useTranslation();
  return (
    <StepChoiceWrapper>
      <Box display="flex" justifyContent="center" mt={4} mb={3}>
        <Typography variant="h2">{t('PORTFOLIO_UPLOAD.QUESTION_1')}</Typography>
      </Box>
      <Box display="flex" justifyContent="center" mx={20}>
        <Typography color={COLORS.typography.main}>
          {t('PORTFOLIO_UPLOAD.INFO_1_1')}{' '}
          <AccentedWord>{t('PORTFOLIO_UPLOAD.INFO_1_2')}</AccentedWord> {t('PORTFOLIO_UPLOAD.OR')}{' '}
          <AccentedWord>{t('PORTFOLIO_UPLOAD.FUNDS')}</AccentedWord>{' '}
          {t('PORTFOLIO_UPLOAD.INFO_1_3')}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" mt={5} gridGap={3} color={COLORS.typography.main}>
        <TileButton
          selected={uploadType === uploadTypes.entities}
          title="Entities / Bonds"
          withCheckbox
          onClick={() => changeUploadType(uploadTypes.entities)}
          icon={<Entities />}
        />
        <TileButton
          selected={uploadType === uploadTypes.funds}
          title="Funds"
          withCheckbox
          onClick={() => changeUploadType(uploadTypes.funds)}
          icon={<Funds />}
        />
      </Box>
      <Box mt={6}>
        <Button disabled={!uploadType} onClick={() => setStep(uploadSteps.second)}>
          Start Portfolio Upload
        </Button>
      </Box>
    </StepChoiceWrapper>
  );
};
